var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg032Briefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492,332.018c11.046,0,20-8.954,20-20v-132c0-44.112-35.888-79.999-80-79.999h-86.074V73.944 c0-30.307-24.656-54.963-54.963-54.963h-69.926c-30.307,0-54.963,24.656-54.963,54.963v26.074H80c-44.112,0-80,35.888-80,80v233 c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80c0-11.046-8.954-20-20-20c-11.046,0-20,8.954-20,20 c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40V270.981h197v30.037c0,11.046,8.954,20,20,20s20-8.954,20-20v-30.037h195 v41.037C472,323.064,480.954,332.018,492,332.018z M206.074,73.944c0-8.251,6.712-14.963,14.963-14.963h69.926 c8.251,0,14.963,6.712,14.963,14.963v26.074h-99.852V73.944z M40,230.982v-50.963c0-22.056,17.944-40,40-40h352 c22.056,0,40,17.944,40,40v50.963H40z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg032Briefcase);
export default __webpack_public_path__ + "static/media/032-briefcase.a313fe4015fb8dd9b1d27a4c8edf114f.svg";
export { ForwardRef as ReactComponent };